"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuleService = void 0;
var lodash_1 = require("lodash");
var operator_1 = require("../condition/operator");
var array_utils_1 = require("../util/array-utils");
var advanced_logic_error_1 = require("../util/advanced-logic-error");
var questionnaire_condition_context_1 = require("../logic/questionnaire-condition-context");
var RuleService = /** @class */ (function () {
    function RuleService(conditionService) {
        this.conditionService = conditionService;
    }
    RuleService.prototype.isRule = function (conditionOrRule) {
        return conditionOrRule.operator !== undefined;
    };
    // this is duplicate but statement-service already imports ruleService.
    RuleService.prototype.isStatement = function (possibleStatement) {
        return possibleStatement.outcome !== undefined;
    };
    RuleService.prototype.includes = function (rule, conditionId) {
        return rule.conditions.some(function (condition) { return condition.id === conditionId; });
    };
    RuleService.prototype.isCondition = function (conditionOrRule) {
        return conditionOrRule.matcher !== undefined;
    };
    RuleService.prototype.eval = function (rule, knowledge) {
        var _this = this;
        if ((0, lodash_1.isEmpty)(rule.conditions) && (0, lodash_1.isEmpty)(rule.quota)) {
            return true;
        }
        var result = false;
        var operator = rule.operator, conditions = rule.conditions;
        var conditionService = this.conditionService;
        if (operator === operator_1.Operator.All) {
            result = array_utils_1.ArrayUtils.every(conditions, function (conditionOrRule) {
                if (_this.isCondition(conditionOrRule)) {
                    return conditionService.eval(conditionOrRule, knowledge);
                }
                if (_this.isRule(conditionOrRule)) {
                    return _this.eval(conditionOrRule, knowledge);
                }
                return false;
            });
        }
        else if (operator === operator_1.Operator.Any) {
            result = array_utils_1.ArrayUtils.some(conditions, function (conditionOrRule) {
                if (_this.isCondition(conditionOrRule))
                    return conditionService.eval(conditionOrRule, knowledge);
                if (_this.isRule(conditionOrRule))
                    return _this.eval(conditionOrRule, knowledge);
                throw new advanced_logic_error_1.AdvancedLogicError('ConditionOrRule has no valid instance (ICondition | IRule)');
            });
        }
        if (result && rule.quota) {
            return conditionService.eval(rule.quota, knowledge);
        }
        return result;
    };
    // TODO: this does not take into account nested rules
    RuleService.prototype.getRuleById = function (entry, ruleId) {
        if (this.isStatement(entry)) {
            return this.getRuleByIdFromStatement(entry, ruleId);
        }
        return this.getRuleByIdFromNodeStatements(entry, ruleId);
    };
    RuleService.prototype.getRootRule = function (statement) {
        return statement.rule;
    };
    RuleService.prototype.getRuleByIdFromNodeStatements = function (qStatements, ruleId) {
        var _this = this;
        // TODO: this does not take into account nested rules
        var statement = qStatements.statements.find(function (statement) {
            return _this.getRuleByIdFromStatement(statement, ruleId);
        });
        if (!statement || !statement.rule) {
            throw new advanced_logic_error_1.AdvancedLogicError("Rule with id ".concat(ruleId, " was not found."));
        }
        // double effort, since we have already calculated this on the above .find it is not needed
        return this.getRuleByIdFromStatement(statement, ruleId);
    };
    RuleService.prototype.getRuleByIdFromStatement = function (statement, ruleId) {
        var _this = this;
        if (!statement || !statement.rule) {
            throw new advanced_logic_error_1.AdvancedLogicError("Rule with id ".concat(ruleId, " was not found."));
        }
        if (statement.rule.id === ruleId) {
            return statement.rule;
        }
        var rule;
        var ruleGetter = function (conditionOrRule) {
            if (_this.isRule(conditionOrRule)) {
                if (conditionOrRule.id === ruleId) {
                    rule = conditionOrRule;
                    return true;
                }
                return conditionOrRule.conditions.some(ruleGetter);
            }
            return false;
        };
        statement.rule.conditions.some(ruleGetter);
        if (!rule) {
            throw new advanced_logic_error_1.AdvancedLogicError("Rule with id ".concat(ruleId, " was not found"));
        }
        return rule;
    };
    RuleService.prototype.isLeafRule = function (rule) {
        var _this = this;
        var _a = rule.conditions, conditions = _a === void 0 ? [] : _a;
        return !conditions.some(function (condition) { return _this.isRule(condition); });
    };
    RuleService.prototype.getParentRuleFromRule = function (rootRule, ruleId) {
        var _this = this;
        var parentNode;
        var ruleGetter = function (conditionOrRule, parent) {
            if (_this.isCondition(conditionOrRule)) {
                return false;
            }
            if (_this.isRule(conditionOrRule)) {
                if (conditionOrRule.id === ruleId) {
                    parentNode = parent;
                    return true;
                }
                parentNode = _this.getParentRuleFromRule(conditionOrRule, ruleId);
                return !!parentNode;
            }
            throw new advanced_logic_error_1.AdvancedLogicError("Rule conditions are not of type Condition or Rule, received ".concat(conditionOrRule.constructor.name));
        };
        rootRule.conditions.some(function (conditionOrRule) {
            return ruleGetter(conditionOrRule, rootRule);
        });
        return parentNode;
    };
    RuleService.prototype.getConditions = function (rule) {
        var _this = this;
        var conditions = rule.conditions.map(function (conditionOrRule) {
            if (_this.isCondition(conditionOrRule)) {
                return conditionOrRule;
            }
            else if (_this.isRule(conditionOrRule)) {
                return _this.getConditions(conditionOrRule);
            }
            throw new advanced_logic_error_1.AdvancedLogicError('Statement conditions are not conforming to either Condition or Rule types');
        });
        return (0, lodash_1.flattenDeep)(conditions);
    };
    RuleService.prototype.hasNodeReferences = function (rule, nodeId) {
        var _this = this;
        return rule.conditions.some(function (conditionOrRule) {
            if (_this.isRule(conditionOrRule)) {
                return _this.hasNodeReferences(conditionOrRule, nodeId);
            }
            else if (_this.isCondition(conditionOrRule) && conditionOrRule.context) {
                //RES-5536 conditionOrRule.context is null when researchers have not selected a context and try to delete the node
                if (conditionOrRule.context.contextType ===
                    questionnaire_condition_context_1.QuestionnaireConditionContext.Answer) {
                    return conditionOrRule.context.questionId === nodeId;
                }
                if (conditionOrRule.context.contextType ===
                    questionnaire_condition_context_1.QuestionnaireConditionContext.Concept) {
                    return conditionOrRule.context.nodeId === nodeId;
                }
            }
            return false;
        });
    };
    RuleService.prototype.getReferencedNodeIds = function (rule, nodeId) {
        var _this = this;
        return rule.conditions.reduce(function (accumulator, conditionOrRule) {
            var _a, _b;
            if (_this.isRule(conditionOrRule)) {
                accumulator = accumulator.concat(_this.getReferencedNodeIds(conditionOrRule, nodeId));
            }
            else if (_this.isCondition(conditionOrRule)) {
                if (((_a = conditionOrRule.context) === null || _a === void 0 ? void 0 : _a.contextType) ===
                    questionnaire_condition_context_1.QuestionnaireConditionContext.Answer &&
                    conditionOrRule.context.questionId !== nodeId) {
                    accumulator.push(conditionOrRule.context.questionId);
                }
                else if (((_b = conditionOrRule.context) === null || _b === void 0 ? void 0 : _b.contextType) ===
                    questionnaire_condition_context_1.QuestionnaireConditionContext.Concept &&
                    conditionOrRule.context.nodeId !== nodeId) {
                    accumulator.push(conditionOrRule.context.nodeId);
                }
            }
            return accumulator;
        }, []);
    };
    return RuleService;
}());
exports.RuleService = RuleService;
